// src/practices/ExploreUIElements.js
import React, { useState, useMemo } from 'react';

import { Link } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PayPalButton from '../../subComponent/paypal.js';


const MasteringXPathforUIAutomation = () => {
  const [textFieldValue, setTextFieldValue] = useState('');
  const [textAreaValue, setTextAreaValue] = useState('');
  const [buttonClickCount, setButtonClickCount] = useState(0);
  const [singleCheckboxChecked, setSingleCheckboxChecked] = useState(false);
  const [multipleCheckboxes, setMultipleCheckboxes] = useState({
    option1: false,
    option2: false,
    option3: false,
  });
  const [selectedRadio, setSelectedRadio] = useState('');
  const [selectedSingleDropdown, setSelectedSingleDropdown] = useState('');
  const [selectedMultiDropdown, setSelectedMultiDropdown] = useState([]);
  const [linkClicked, setLinkClicked] = useState(false);
  const [imageClicked, setImageClicked] = useState(false);
  const [tableSortColumn, setTableSortColumn] = useState(null);
  const [tooltipHovered, setTooltipHovered] = useState(false);
  const [sliderValue, setSliderValue] = useState(50);
  const [progressBarValue, setProgressBarValue] = useState(30);
  const [modalVisible, setModalVisible] = useState(false);
  const [datePickerValue, setDatePickerValue] = useState('');
  const [fileSelected, setFileSelected] = useState(null);
  const [draggedItem, setDraggedItem] = useState(null);
  const [droppedInTarget, setDroppedInTarget] = useState(false);
  const [iframeMessage, setIframeMessage] = useState('');
  const [dynamicContent, setDynamicContent] = useState('Initial Content');
  const [notificationVisible, setNotificationVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('tab1');
  const [accordionOpen, setAccordionOpen] = useState(null);
  const [virtualScrollIndex, setVirtualScrollIndex] = useState(0);
  const [tableSortDirection, setTableSortDirection] = useState('asc');
  const [collapseStates, setCollapseStates] = useState({});

  const countries = ['USA', 'Canada', 'UK', 'India', 'Australia'];
  const multiSelectOptions = ['Option A', 'Option B', 'Option C', 'Option D'];
  const radioOptions = ['Radio 1', 'Radio 2', 'Radio 3'];


  const sortedTableData = useMemo(() => {
  const tableData = [
    { id: 1, name: 'Zui', age: 30 },
    { id: 3, name: 'Bob', age: 25 },
    { id: 2, name: 'Charlie', age: 35 },
    { id: 5, name: 'Ashley', age: 30 },
    { id: 4, name: 'Nat', age: 25 },
    { id: 6, name: 'Jim', age: 35 },
  ];

  
    if (!tableSortColumn) {
      return tableData;
    }

    const sortedData = [...tableData].sort((a, b) => {
      const valueA = a[tableSortColumn];
      const valueB = b[tableSortColumn];

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return tableSortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      } else {
        return tableSortDirection === 'asc' ? valueA - valueB : valueB - valueA;
      }
    });

    return sortedData;
  }, [tableSortColumn, tableSortDirection]);

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      background: 'linear-gradient(to right, #1e3a8a, #3730a3)',
      fontFamily: 'Arial, sans-serif',
      padding: '20px',
    },
    contentWrapper: {
      maxWidth: '960px',
      width: '100%',
      backgroundColor: 'white',
      padding: '30px',
      borderRadius: '8px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
      marginBottom: '20px',
    },
    sectionTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#374151',
      marginBottom: '15px',
      borderBottom: '2px solid #d1d5db',
      paddingBottom: '5px',
    },
    elementRow: {
      marginBottom: '20px',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '20px',
      alignItems: 'center',
    },
    label: {
      fontWeight: '500',
      color: '#4b5563',
      marginBottom: '5px',
      display: 'block',
    },
    input: {
      width: 'calc(100% - 12px)',
      padding: '8px',
      border: '1px solid #d1d5db',
      borderRadius: '4px',
    },
    textarea: {
      width: 'calc(100% - 12px)',
      padding: '8px',
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      minHeight: '80px',
    },
    button: {
      padding: '10px 15px',
      backgroundColor: '#1e40af',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    checkboxGroup: {
      display: 'flex',
      flexDirection: 'column',
    },
    checkboxLabel: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '5px',
      color: '#4b5563',
    },
    checkboxInput: {
      marginRight: '8px',
    },
    radioGroup: {
      display: 'flex',
      flexDirection: 'column',
    },
    radioLabel: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '5px',
      color: '#4b5563',
    },
    radioInput: {
      marginRight: '8px',
    },
    select: {
      width: '100%',
      padding: '8px',
      border: '1px solid #d1d5db',
      borderRadius: '4px',
    },
    multiSelect: {
      height: '80px',
    },
    link: {
      color: '#1e40af',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    image: {
      maxWidth: '100px',
      height: 'auto',
      border: '1px solid #d1d5db',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    th: {
      border: '1px solid #d1d5db',
      padding: '8px',
      fontWeight: 'bold',
      textAlign: 'left',
      cursor: 'pointer',
      userSelect: 'none',
    },
    td: {
      border: '1px solid #d1d5db',
      padding: '8px',
    },
    tooltip: {
      position: 'relative',
      display: 'inline-block',
    },
    tooltipText: {
      visibility: 'hidden',
      width: '120px',
      backgroundColor: 'black',
      color: '#fff',
      textAlign: 'center',
      borderRadius: '6px',
      padding: '5px',
      position: 'absolute',
      zIndex: 1,
      bottom: '125%',
      left: '50%',
      marginLeft: '-60px',
      opacity: 0,
      transition: 'opacity 0.3s',
    },
    tooltipHover: {
      visibility: 'visible',
      opacity: 1,
    },
    slider: {
      width: '100%',
    },
    progressBar: {
      width: '100%',
      height: '20px',
      backgroundColor: '#f3f4f6',
      borderRadius: '4px',
      overflow: 'hidden',
    },
    progressBarFill: {
      backgroundColor: '#4caf50',
      height: '100%',
      width: `${progressBarValue}%`,
      borderRadius: '4px',
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    modalContent: {
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      maxWidth: '400px',
      width: '100%',
      position: 'relative',
    },
    modalCloseButton: {
      position: 'absolute',
      top: '10px',
      right: '10px',
      cursor: 'pointer',
      border: 'none',
      background: 'none',
      fontSize: '16px',
    },
    tabContainer: {
      borderBottom: '1px solid #d1d5db',
      marginBottom: '15px',
    },
    tabButton: {
      padding: '10px 15px',
      border: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      borderBottom: '2px solid transparent',
      fontWeight: 'bold',
      color: '#4b5563',
    },
    tabButtonActive: {
      borderBottomColor: '#1e40af',
      color: '#1e40af',
    },
    tabContent: {
      padding: '15px 0',
    },
    accordionItem: {
      border: '1px solid #d1d5db',
      marginBottom: '10px',
      borderRadius: '4px',
      overflow: 'hidden',
    },
    accordionHeader: {
      backgroundColor: '#f3f4f6',
      padding: '10px 15px',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: '500',
      color: '#4b5563',
    },
    accordionContent: {
      padding: '15px',
      backgroundColor: 'white',
    },
    virtualScrollContainer: {
      height: '150px',
      overflowY: 'auto',
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      padding: '8px',
    },
    virtualScrollItem: {
      padding: '5px 0',
      borderBottom: '1px dotted #eee',
    },
    outputBox: {
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      backgroundColor: '#f9f9f9',
      padding: '10px',
      fontSize: '14px',
      color: '#374151',
      minHeight: '30px',
    },
    outputLabel: {
      fontWeight: 'bold',
      marginBottom: '5px',
      color: '#4b5563',
      display: 'block',
    },
    xpathContainer: {
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      padding: '10px',
      margin: '10px 0',
      backgroundColor: '#f9f9f9',
    },
    collapseButton: {
      width: '100%',
      textAlign: 'left',
      padding: '8px',
      backgroundColor: '#e5e7eb',
      border: 'none',
      cursor: 'pointer',
      marginBottom: '5px',
    },
    collapseContent: {
      padding: '10px',
      borderTop: '1px solid #d1d5db',
      display: 'none',
    },
    collapseContentVisible: {
      display: 'block',
    },
    xpathText: {
      fontFamily: 'monospace',
      fontSize: '14px',
      color: '#374151',
    },
    xpathConcept: {
      fontSize: '12px',
      color: '#777',
      marginTop: '5px',
    },
  };

  const handleButtonClick = () => {
    setButtonClickCount(buttonClickCount + 1);
  };

  const handleSingleCheckboxChange = (e) => {
    setSingleCheckboxChecked(e.target.checked);
  };

  const handleMultipleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setMultipleCheckboxes({ ...multipleCheckboxes, [name]: checked });
  };

  const handleRadioChange = (e) => {
    setSelectedRadio(e.target.value);
  };

  const handleSingleDropdownChange = (e) => {
    setSelectedSingleDropdown(e.target.value);
  };

  const handleMultiDropdownChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map((option) => option.value);
    setSelectedMultiDropdown(selectedOptions);
  };

  const handleLinkClick = (e) => {
    e.preventDefault();
    setLinkClicked(true);
    setTimeout(() => setLinkClicked(false), 2000);
  };

  const handleImageClick = () => {
    setImageClicked(true);
    setTimeout(() => setImageClicked(false), 2000);
  };

  const handleTableSort = (column) => {
    if (column === tableSortColumn) {
      setTableSortDirection(tableSortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setTableSortColumn(column);
      setTableSortDirection('asc');
    }
  };

  const handleSliderChange = (e) => {
    setSliderValue(parseInt(e.target.value));
  };

  const handleProgressBarIncrement = () => {
    setProgressBarValue((prev) => Math.min(100, prev + 10));
  };

  const handleModalToggle = () => {
    setModalVisible(!modalVisible);
  };

  const handleFileSelect = (e) => {
    setFileSelected(e.target.files[0]?.name || null);
  };

  const handleDragStart = (e, itemName) => {
    setDraggedItem(itemName);
    setDroppedInTarget(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    if (draggedItem) {
      setDroppedInTarget(true);
      setDraggedItem(null);
    }
  };

  const handleIframeLoad = () => {
    setIframeMessage('Iframe loaded');
  };

  const updateDynamicContent = () => {
    setDynamicContent(`Updated at ${new Date().toLocaleTimeString()}`);
  };

  const showNotification = () => {
    setNotificationVisible(true);
    setTimeout(() => setNotificationVisible(false), 3000);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleAccordionToggle = (item) => {
    setAccordionOpen(accordionOpen === item ? null : item);
  };

  const handleVirtualScroll = (e) => {
    setVirtualScrollIndex(e.target.scrollTop);
  };

  const virtualScrollItems = Array.from({ length: 50 }, (_, i) => `Item ${i + 1}`);

  const toggleCollapse = (id) => {
    setCollapseStates({ ...collapseStates, [id]: !collapseStates[id] });
  };

  const renderXPathSection = (id, label, xpath, concept) => (

    <div style={styles.xpathContainer}>
      <button style={styles.collapseButton} onClick={() => toggleCollapse(id)}>
        {label} {collapseStates[id] ? '▲' : '▼'}
      </button>
      <div style={{ ...styles.collapseContent, ...(collapseStates[id] && styles.collapseContentVisible) }}>
        <p style={styles.xpathText}>{xpath}</p>
          <p style={styles.xpathConcept}>{concept}</p>
        </div>
      </div>
    );
  
    return (
      <HelmetProvider>
            <Helmet>
              <title>XPath Practice for Selenium: Locate Web Elements Like a Pro</title>
              <meta http-equiv="Content-type" content="text/html;charset=UTF-8"></meta>
              <meta name="description" content="Master XPath for robust UI automation! TesterBud offers a dedicated iframe website for testing and practicing your XPath skills. Learn to locate elements precisely for Selenium and other automation frameworks." />
              <meta name="keywords" content="xpath, xpath practise, xpath practise website, free xpath practise, xpath online, xpath in selenium, xpxpath, xpath practise, xpath practise website, free xpath practise, xpath online, xpath in selenium, xpath finder online, xpath finder online, xpath practise exercise, tutorial, learn xpath, selenium xpath, web automation xpath, ui automation xpath selectors, locate elements xpath, xpath testing tool, xpath tester, xpath examples automation, advanced xpath, relative xpath, absolute xpath, xpath axes, xpath functions, iframe xpath, shadow DOM xpath, dynamic xpath, robust xpath, reliable xpath, xpath web scraping, testerbud xpath, testerbud iframe xpathath finder online, xpath finder online, xpath practise exercise" />
              <meta name="robots" content="index, follow" />
              <meta name="author" content="TesterBud Team" />
              <meta property="og:title" content="XPath Practice for Selenium: Locate Web Elements Like a Pro" />
              <meta property="og:description" content="Master XPath for robust UI automation! TesterBud offers a dedicated iframe website for testing and practicing your XPath skills. Learn to locate elements precisely for Selenium and other automation frameworks." />
              <meta name="keywords" content="xpath, xpath practise, xpath practise website, free xpath practise, xpath online, xpath in selenium, xpxpath, xpath practise, xpath practise website, free xpath practise, xpath online, xpath in selenium, xpath finder online, xpath finder online, xpath practise exercise, tutorial, learn xpath, selenium xpath, web automation xpath, ui automation xpath selectors, locate elements xpath, xpath testing tool, xpath tester, xpath examples automation, advanced xpath, relative xpath, absolute xpath, xpath axes, xpath functions, iframe xpath, shadow DOM xpath, dynamic xpath, robust xpath, reliable xpath, xpath web scraping, testerbud xpath, testerbud iframe xpathath finder online, xpath finder online, xpath practise exercise" />
              <meta property="og:type" content="website" />
              <meta property="og:url" content="https://testerbud.com/practice-xpath" />
              <meta name="geo.region" content="GLOBAL" />
              <meta name="geo.placename" content="Global" />
            </Helmet>
      <div style={styles.container}>
        <div style={styles.contentWrapper}>
          <h2 style={{ ...styles.sectionTitle, textAlign: 'center', marginBottom: '25px' }}>Mastering XPath for UI Automation</h2>
          <p style={{ color: '#4b5563', marginBottom: '20px', textAlign: 'left', fontSize: '16px' }}>
            <b>
              <i>Mastering XPath for UI Automation</i> is your interactive guide to learning and practicing XPath strategies for UI automation. Challenge yourself with elements of increasing complexity, uncover the best XPath techniques, and refine your ability to locate elements efficiently. Each task tests your skills, while collapsible solutions reveal the correct XPath and concepts used. Elevate your automation expertise and build more reliable test scripts! 🚀
            </b>
          </p>
  
          <h3 style={styles.sectionTitle}>Basic Elements</h3>
          <div style={styles.elementRow}>
            <div>
              <label style={styles.label} htmlFor="textField">Text Field (Input Box):</label>
              <input
                type="text"
                id="textField"
                style={styles.input}
                value={textFieldValue}
                onChange={(e) => setTextFieldValue(e.target.value)}
              />
            </div>
            <div>
              <label style={styles.outputLabel}>Output:</label>
              <div style={styles.outputBox}>{textFieldValue}</div>
            </div>
          </div>
  
          <div style={styles.elementRow}>
            <div>
              <label style={styles.label} htmlFor="textArea">Text Area:</label>
              <textarea
                id="textArea"
                style={styles.textarea}
                value={textAreaValue}
                onChange={(e) => setTextAreaValue(e.target.value)}
              ></textarea>
            </div>
            <div>
              <label style={styles.outputLabel}>Output:</label>
              <div style={styles.outputBox}>{textAreaValue}</div>
            </div>
          </div>
  
          <div style={styles.elementRow}>
            <div>
              <label style={styles.label}>Button:</label>
              <button style={styles.button} onClick={handleButtonClick}>Click Me</button>
            </div>
            <div>
              <label style={styles.outputLabel}>Output:</label>
              <div style={styles.outputBox}>Clicked {buttonClickCount} times</div>
            </div>
          </div>
  
          <div style={styles.elementRow}>
            <div>
              <label style={styles.label}>Checkbox (Single):</label>
              <label style={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  style={styles.checkboxInput}
                  checked={singleCheckboxChecked}
                  onChange={handleSingleCheckboxChange}
                />
                Single Option
              </label>
            </div>
            <div>
              <label style={styles.outputLabel}>Output:</label>
              <div style={styles.outputBox}>{singleCheckboxChecked ? 'Checked' : 'Unchecked'}</div>
            </div>
          </div>
  
          <div style={styles.elementRow}>
            <div>
              <label style={styles.label}>Checkboxes (Multiple):</label>
              <div style={styles.checkboxGroup}>
                <label style={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    style={styles.checkboxInput}
                    name="option1"
                    checked={multipleCheckboxes.option1}
                    onChange={handleMultipleCheckboxChange}
                  />
                  Option 1
                </label>
                <label style={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    style={styles.checkboxInput}
                    name="option2"
                    checked={multipleCheckboxes.option2}
                    onChange={handleMultipleCheckboxChange}
                  />
                  Option 2
                </label>
                <label style={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    style={styles.checkboxInput}
                    name="option3"
                    checked={multipleCheckboxes.option3}
                    onChange={handleMultipleCheckboxChange}
                  />
                  Option 3
                </label>
              </div>
            </div>
            <div>
              <label style={styles.outputLabel}>Output:</label>
              <div style={styles.outputBox}>
                Checked: {Object.keys(multipleCheckboxes)
                  .filter((key) => multipleCheckboxes[key])
                  .join(', ')}
              </div>
            </div>
          </div>
  
          <div style={styles.elementRow}>
            <div>
              <label style={styles.label}>Radio Buttons:</label>
              <div style={styles.radioGroup}>
                {radioOptions.map((option) => (
                  <label key={option} style={styles.radioLabel}>
                    <input
                      type="radio"
                      style={styles.radioInput}
                      name="radioGroup"
                      value={option}
                      checked={selectedRadio === option}
                      onChange={handleRadioChange}
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>
            <div>
              <label style={styles.outputLabel}>Output:</label>
              <div style={styles.outputBox}>{selectedRadio || 'No option selected'}</div>
            </div>
          </div>
  
          <div style={styles.elementRow}>
            <div>
              <label style={styles.label} htmlFor="singleDropdown">Dropdown (Single Select):</label>
              <select
                id="singleDropdown"
                style={styles.select}
                value={selectedSingleDropdown}
                onChange={handleSingleDropdownChange}
              >
                <option value="">Select a country</option>
                {countries.map((country) => (
                  <option key={country} value={country}>{country}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={styles.outputLabel}>Output:</label>
              <div style={styles.outputBox}>{selectedSingleDropdown || 'No option selected'}</div>
            </div>
          </div>
  
          <div style={styles.elementRow}>
            <div>
              <label style={styles.label} htmlFor="multiDropdown">Dropdown (Multi-Select):</label>
              <select
                id="multiDropdown"
                style={{ ...styles.select, ...styles.multiSelect }}
                multiple
                value={selectedMultiDropdown}
                onChange={handleMultiDropdownChange}
              >
                {multiSelectOptions.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={styles.outputLabel}>Output:</label>
              <div style={styles.outputBox}>{selectedMultiDropdown.length > 0 ? selectedMultiDropdown.join(', ') : 'No options selected'}</div>
            </div>
          </div>
  
          <h3 style={styles.sectionTitle}>Interactive Elements</h3>
          <div style={styles.elementRow}>
            <div>
              <label style={styles.label}>Link (Anchor Tag):</label>
              <a href="abc" style={styles.link} onClick={handleLinkClick}>Click Me</a>
            </div>
            <div>
              <label style={styles.outputLabel}>Output:</label>
              <div style={styles.outputBox}>{linkClicked ? 'Link Clicked!' : 'Click the link'}</div>
            </div>
          </div>
  
          <div style={styles.elementRow}>
            <div>
              <label style={styles.label}>Image:</label>
              <img
                src={require('../../logo192.png')}
                alt="Placeholder"
                style={styles.image}
                onClick={handleImageClick}
              />
            </div>
            <div>
              <label style={styles.outputLabel}>Output:</label>
              <div style={styles.outputBox}>{imageClicked ? 'Image Clicked!' : 'Click the image'}</div>
            </div>
          </div>
  
          <div style={styles.elementRow}>
            <div>
              <label style={styles.label}>Table & Grid:</label>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th} onClick={() => handleTableSort('id')}>ID</th>
                    <th style={styles.th} onClick={() => handleTableSort('name')}>Name</th>
                    <th style={styles.th} onClick={() => handleTableSort('age')}>Age</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedTableData.map((row) => (
                    <tr key={row.id}>
                      <td style={styles.td}>{row.id}</td>
                      <td style={styles.td}>{row.name}</td>
                      <td style={styles.td}>{row.age}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {tableSortColumn && <p style={{ marginTop: '5px',fontSize: '12px', color: '#777' }}>Sorted by: {tableSortColumn}</p>}
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>{tableSortColumn ? `Table sorted by ${tableSortColumn}` : 'Click a table header to "sort"'}</div>
          </div>
        </div>

        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Tooltip:</label>
            <div
              style={styles.tooltip}
              onMouseEnter={() => setTooltipHovered(true)}
              onMouseLeave={() => setTooltipHovered(false)}
            >
              Hover Me
              <span style={{ ...styles.tooltipText, ...(tooltipHovered && styles.tooltipHover) }}>
                This is a tooltip!
              </span>
            </div>
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>{tooltipHovered ? 'Tooltip is visible' : 'Hover over "Hover Me"'}</div>
          </div>
        </div>

        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Slider:</label>
            <input
              type="range"
              style={styles.slider}
              min="0"
              max="100"
              value={sliderValue}
              onChange={handleSliderChange}
            />
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>Slider Value: {sliderValue}</div>
          </div>
        </div>

        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Progress Bar:</label>
            <div style={styles.progressBar}>
              <div style={styles.progressBarFill}></div>
            </div>
            <button style={styles.button} onClick={handleProgressBarIncrement}>Increment Progress</button>
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>Progress: {progressBarValue}%</div>
          </div>
        </div>

        <h3 style={styles.sectionTitle}>Complex UI Components</h3>
        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Modal & Popup:</label>
            <button style={styles.button} onClick={handleModalToggle}>Show Modal</button>
            {modalVisible && (
              <div style={styles.modalOverlay}>
                <div style={styles.modalContent}>
                  <button style={styles.modalCloseButton} onClick={handleModalToggle}>X</button>
                  <p>This is a modal!</p>
                </div>
              </div>
            )}
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>{modalVisible ? 'Modal is open' : 'Click "Show Modal"'}</div>
          </div>
        </div>

        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Date Picker & Calendar:</label>
            <input
              type="text"
              style={styles.input}
              placeholder="YYYY-MM-DD (Simulated)"
              value={datePickerValue}
              onChange={(e) => setDatePickerValue(e.target.value)}
            />
            <p style={{ fontSize: '12px', color: '#777', marginTop: '5px' }}>(This is a basic input for demonstration. Integrate a datepicker library for full functionality)</p>
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>{datePickerValue || 'No date selected (simulated)'}</div>
          </div>
        </div>

        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>File Upload & Download:</label>
            <input type="file" style={{ width: '100%' }} onChange={handleFileSelect} />
            {fileSelected && <p style={{ marginTop: '5px', fontSize: '12px', color: '#777' }}>Selected file: {fileSelected}</p>}
            <button style={styles.button} onClick={() => alert('Simulating Download')}>Simulate Download</button>
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>{fileSelected ? `File "${fileSelected}" selected` : 'No file selected'}<br />(Download simulated via alert)</div>
          </div>
        </div>

        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Drag and Drop Elements:</label>
            <div
              style={{ border: '1px dashed #ccc', padding: '10px', width: '100px', textAlign: 'center', cursor: 'grab' }}
              draggable
              onDragStart={(e) => handleDragStart(e, 'Draggable Item')}
            >
              Drag Me
            </div>
            <div
              style={{ border: '1px solid #ccc', padding: '10px', width: '100px', textAlign: 'center', marginTop: '10px' }}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              Drop Here
            </div>
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>
              {draggedItem ? `Dragging: ${draggedItem}` : droppedInTarget ? 'Dropped!' : 'Drag "Drag Me" to "Drop Here"'}
            </div>
          </div>
        </div>

        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Iframe:</label>
            <iframe title='iframe-practice'
              src="https://example.com"
              width="100%"
              height="150px"
              style={{ border: '1px solid #d1d5db' }}
              onLoad={handleIframeLoad}
            ></iframe>
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>{iframeMessage || 'Iframe loading...'}</div>
          </div>
        </div>

        <h3 style={styles.sectionTitle}>Advanced UI Elements</h3>
        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Dynamic Content (Simulated):</label>
            <div style={styles.outputBox}>{dynamicContent}</div>
            <button style={styles.button} onClick={updateDynamicContent}>Update Content</button>
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>Click "Update Content" to see changes</div>
          </div>
        </div>

        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Notifications & Toast Messages:</label>
            <button style={styles.button} onClick={showNotification}>Show Notification</button>
            {notificationVisible && (
              <div style={{ position: 'absolute', top: '20px', right: '20px', backgroundColor: '#d4edda', color: '#155724', padding: '15px', borderRadius: '4px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
                Success! Operation completed.
              </div>
            )}
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>{notificationVisible ? 'Notification shown' : 'Click "Show Notification"'}</div>
          </div>
        </div>

        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Tabs:</label>
            <div style={styles.tabContainer}>
              <button
                style={{ ...styles.tabButton, ...(activeTab === 'tab1' && styles.tabButtonActive) }}
                onClick={() => handleTabChange('tab1')}
              >
                Tab 1
              </button>
              <button
                style={{ ...styles.tabButton, ...(activeTab === 'tab2' && styles.tabButtonActive) }}
                onClick={() => handleTabChange('tab2')}
              >
                Tab 2
              </button>
            </div>
            <div style={styles.tabContent}>
              {activeTab === 'tab1' && <p>Content of Tab 1</p>}
              {activeTab === 'tab2' && <p>Content of Tab 2</p>}
            </div>
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>Active Tab: {activeTab}</div>
          </div>
        </div>

        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Accordion:</label>
            <div style={styles.accordionItem}>
              <div style={styles.accordionHeader} onClick={() => handleAccordionToggle('item1')}>
                Item 1
                <span>{accordionOpen === 'item1' ? '-' : '+'}</span>
              </div>
              {accordionOpen === 'item1' && <div style={styles.accordionContent}>Content of Item 1.</div>}
            </div>
            <div style={styles.accordionItem}>
              <div style={styles.accordionHeader} onClick={() => handleAccordionToggle('item2')}>
                Item 2
                <span>{accordionOpen === 'item2' ? '-' : '+'}</span>
              </div>
              {accordionOpen === 'item2' && <div style={styles.accordionContent}>Content of Item 2.</div>}
            </div>
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>Accordion Open: {accordionOpen || 'None'}</div>
          </div>
        </div>

        <div style={styles.elementRow}>
          <div>
            <label style={styles.label}>Virtual Scroll (Simulated):</label>
            <div style={styles.virtualScrollContainer} onScroll={handleVirtualScroll}>
              {virtualScrollItems.map((item, index) => (
                <div key={index} style={styles.virtualScrollItem}>{item}</div>
              ))}
            </div>
          </div>
          <div>
            <label style={styles.outputLabel}>Output:</label>
            <div style={styles.outputBox}>Scroll Position: {virtualScrollIndex}</div>
          </div>
        </div>

        <h3 style={styles.sectionTitle}>XPath Examples</h3>

        {renderXPathSection(
          'textFieldXPath',
          'Text Field XPath',
          "//input[@id='textField' and @type='text']",
          'Using ID and attribute'
        )}

        {renderXPathSection(
          'textAreaXPath',
          'Text Area XPath',
          "//textarea[@id='textArea']",
          'Using ID'
        )}

        {renderXPathSection(
          'buttonXPath',
          'Button XPath',
          "//button[text()='Click Me']",
          'Using text content'
        )}

        {renderXPathSection(
          'singleCheckboxXPath',
          'Single Checkbox XPath',
          "//input[@type='checkbox' and ancestor::label[contains(., 'Single Option')]]",
          'Using ancestor and contains text'
        )}

        {renderXPathSection(
          'multipleCheckboxesXPath',
          'Multiple Checkboxes XPath',
          "//input[@type='checkbox' and ancestor::label[contains(., 'Option 2')]]",
          'Using ancestor and contains text'
        )}

        {renderXPathSection(
          'radioButtonsXPath',
          'Radio Buttons XPath',
          "//input[@type='radio' and ancestor::label[contains(., 'Radio 3')]]",
          'Using ancestor and contains text'
        )}

        {renderXPathSection(
          'singleDropdownXPath',
          'Single Dropdown XPath',
          "//select[@id='singleDropdown']/option[text()='India']",
          'Using ID and option text'
        )}

        {renderXPathSection(
          'multiDropdownXPath',
          'Multi-Select Dropdown XPath',
          "//select[@id='multiDropdown']/option[text()='Option B']",
          'Using ID and option text'
        )}

        {renderXPathSection(
          'linkXPath',
          'Link XPath',
          "//a[text()='Click Me']",
          'Using text content'
        )}

        {renderXPathSection(
          'imageXPath',
          'Image XPath',
          "//img[@alt='Placeholder']",
          'Using alt attribute'
        )}

        {renderXPathSection(
          'tableSortableColumnXPath',
          'Table Sortable Column XPath',
          "//th[text()='Age']",
          'Using th text content'
        )}

        {renderXPathSection(
          'tooltipXPath',
          'Tooltip XPath',
          "//div[contains(., 'Hover Me')]/span",
          'Using contains text'
        )}

        {renderXPathSection(
          'sliderXPath',
          'Slider XPath',
          "//input[@type='range']",
          'Using input type'
        )}

        {renderXPathSection(
          'progressBarXPath',
          'Progress Bar XPath',
          "//div[@class='progressBarFill']",
          'Using class attribute'
        )}

        {renderXPathSection(
          'modalXPath',
          'Modal XPath',
          "//div[contains(@class, 'modalContent')]",
          'Using contains class'
        )}

        {renderXPathSection(
          'datePickerXPath',
          'Date Picker XPath',
          "//input[@placeholder='YYYY-MM-DD (Simulated)']",
          'Using placeholder'
        )}

        {renderXPathSection(
          'fileUploadXPath',
          'File Upload XPath',
          "//input[@type='file']",
          'Using input type'
        )}

        {renderXPathSection(
          'dragDropXPath',
          'Drag and Drop XPath',
          "//div[text()='Drag Me']",
          'Using text content'
        )}

        {renderXPathSection(
          'iframeXPath',
          'Iframe XPath',
          "//iframe[@title='iframe-practice']",
          'Using title attribute'
        )}

        {renderXPathSection(
          'dynamicContentXPath',
          'Dynamic Content XPath',
          "//div[contains(., 'Updated at')]",
          'Using contains text'
        )}

        {renderXPathSection(
          'notificationXPath',
          'Notification XPath',
          "//div[contains(., 'Success! Operation completed.')]",
          'Using contains text'
        )}

        {renderXPathSection(
          'tabsXPath',
          'Tabs XPath',
          "//button[text()='Tab 2']",
          'Using button text'
        )}

        {renderXPathSection(
          'accordionXPath',
          'Accordion XPath',
          "//div[contains(., 'Item 2') and @class='accordionHeader']",
          'Using contains text and class'
        )}

        {renderXPathSection(
          'virtualScrollXPath',
          'Virtual Scroll XPath',
          "//div[contains(., 'Item 25')]",
          'Using contains text'
        )}

        <div className="section-divider"></div>
        <div className="donation-request">
          <h3>Support This Platform 💙</h3>
          <p>
            This platform is built with passion for learners like you, but keeping it running comes with costs.
            If you've found value in our services, please consider making a donation to support our cloud hosting and development efforts.
          </p>
          <p>
            Donate using any of the links below if you've learned something valuable today! Your support helps us
            continue providing quality learning resources for aspiring QA professionals.
          </p>
          <p>
            Together, let's build a community where QA automation learning is accessible to all!
          </p>
         <center> <PayPalButton /></center>
        </div>
        <div className="section-divider"></div>
        <br></br>
                                   <center> <Link to="/" style={{ textDecoration: "none" }}>
                                <button style={{ backgroundColor: '#1e40af', color: 'white', border: '1px solid black', padding: '10px 15px', borderRadius: '5px', cursor: 'pointer' }}>
                                    Back To Home Page ➡️
                                </button>
                            </Link>
                            </center>
      </div>
    </div>
    </HelmetProvider>
  );
};

export default MasteringXPathforUIAutomation;